register('hp-shop-by-slider', {
  onLoad() {
    const $container = this.container,
          self = this;
    const rowsSlider = this.container.querySelector('[tiny-slider]');
    this._shopbySlider(rowsSlider);

    const ro = new ResizeObserver( debounce(function(entries){
      for (let entry of entries) {
        self._reachRightEdge();
      }
    }, 200));
    ro.observe($container);
  },
  _reachRightEdge(){
    const $container = this.container,
    rowsSlider = this.container.querySelector('[tiny-slider]');
    const dept_wrapper = rowsSlider ? rowsSlider.closest('.hp-dept-wrapper') : false;
    if ( !dept_wrapper ) { return ;}
    const innerboundingRect = dept_wrapper.getBoundingClientRect();
    dept_wrapper.style.marginRight = -1 * innerboundingRect.left + 'px';
  },
  _shopbySlider(rowsSlider){
    if (!rowsSlider) { return; }

    var slider = tns({
        container: rowsSlider,
        items: 1.5,
        slideBy: 1,
        center: false,
        autoplay: false,
        controls: false,
        nav: true,
        controlsPosition: 'bottom',
        navPosition: 'bottom',
        mouseDrag: true,
        loop: false,
        preventScrollOnTouch: 'auto',
        swipeAngle: false,
        responsive: {
          768: {
            items: rowsSlider.dataset.count == 6 ? 6.5 : 4.5,
            slideBy: rowsSlider.dataset.count == 6 ? 6 : 4,
            controls: true,
            nav: false,
          }
        }
    });
  },
  onUnload() {
    this.container.off(this.namespace);
  },
});

load('hp-shop-by-slider');